import { formatPersonName } from './formatPersonName';

const ACTIVE_CONTACT_SESSION_KEY = 'config-go-active-contact';

export function buildSelectedContactPayload(contact) {
  if (!contact) return null;

  const name = formatPersonName(`${contact.first_name || ''} ${contact.last_name || ''}`.trim());
  return {
    id: contact.id,
    name,
    address: contact.address || '',
    city: contact.city || '',
    postalCode: contact.postal_code || contact.postalCode || '',
    phone: contact.phone || '',
    email: contact.email || '',
    country: contact.country || '',
  };
}

export function persistActiveContactForConfigurator(contact) {
  const payload = buildSelectedContactPayload(contact);
  if (!payload) return null;

  try {
    sessionStorage.setItem(ACTIVE_CONTACT_SESSION_KEY, JSON.stringify(payload));
  } catch {
    // Ignore storage errors (private browsing, quota, etc.)
  }

  return payload;
}

export function readActiveContactForConfigurator() {
  try {
    const raw = sessionStorage.getItem(ACTIVE_CONTACT_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearActiveContactForConfigurator() {
  try {
    sessionStorage.removeItem(ACTIVE_CONTACT_SESSION_KEY);
  } catch {
    // Ignore storage errors
  }
}

export function resolveConfiguratorContactState(locationState) {
  const fromState = locationState?.selectedContact;
  if (fromState?.name || fromState?.email) {
    return fromState;
  }

  return readActiveContactForConfigurator();
}

export function buildConfiguratorNavigationState(locationState, overrides = {}) {
  const selectedContact = resolveConfiguratorContactState(locationState);

  // Only forward safe navigation fields — never carry edit/load payloads into a new configurator.
  const safeState = {
    returnTo: locationState?.returnTo,
    fromContactProfile: locationState?.fromContactProfile,
    from: locationState?.from,
  };

  return {
    ...safeState,
    ...overrides,
    ...(selectedContact ? { selectedContact } : {}),
  };
}
